
import { defineComponent, reactive, ref, toRefs, watch } from 'vue'
import { ElMessage } from 'element-plus'
import { toResult } from '@/utils/toResult'
import { addApi, dropdownOfEnterprise } from '../api'
import { enumToOption } from '@/utils'
import { moduleType } from '../config'

export default defineComponent({
  name: 'enterprise-api-setting-add-dialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:visible', 'refresh-list'],
  setup(props, { emit }) {
    const formRef = ref<HTMLElement | any>(null)
    const state = reactive({
      isShow: false,
      loading: false,
      remoteLoading: false,
      enterpriseOptions: [] as { label: string; value: string }[],
      formData: {
        companyUuid: '',
        notifyUrl: '',
        modules: [] as number[],
        status: 1
      } as any,
      rules: {
        companyUuid: [
          { required: true, message: '请选择企业', trigger: 'change' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ]
      }
    })

    const moduleOptions = enumToOption(moduleType)

    watch(
      () => props.visible,
      val => {
        state.isShow = val
        if (val) {
          state.formData = {
            companyUuid: '',
            notifyUrl: '',
            modules: [],
            status: 1
          }
        }
      },
      { immediate: true }
    )

    /**
     * @description: 关闭弹窗
     * @return {void}
     */
    const handleClose = (): void => {
      state.isShow = false
      formRef.value?.resetFields()
      emit('update:visible', false)
    }

    /**
     * @description: 远程搜索企业
     * @param {string} val
     * @return {void}
     */
    const remoteMethod = (val: string): void => {
      dropdownOfEnterprise({ value: val }).then((res: any) => {
        state.enterpriseOptions = (res.data || []).map((item: any) => ({
          label: item.value,
          value: item.key
        }))
      })
    }

    /**
     * @description: 提交表单
     * @return {void}
     */
    const handleSubmit = async (): Promise<void> => {
      state.loading = true
      const [err, , msg] = await toResult(addApi(state.formData))
      state.loading = false
      if (err) return
      ElMessage.success(msg || '新增成功')
      emit('refresh-list')
      handleClose()
    }

    /**
     * @description: 校验
     * @return {void}
     */
    const handleValidate = (): void => {
      formRef.value?.validate((valid: boolean) => {
        if (!valid) return
        handleSubmit()
      })
    }

    return {
      ...toRefs(state),
      formRef,
      moduleOptions,
      handleClose,
      handleValidate,
      remoteMethod
    }
  }
})
